export default {
	path: '/danger-occur-video',
	redirect: '/danger-occur-video',
	component: () => import('@/views/layout/Default'),
	children: [
		{
			path: '/',
			name: 'DangerOccurVideoHome',
			component: () => import('@/views/biz/DangerOccurVideo'),
		},
	],
};
